import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import LockPersonIcon from "@mui/icons-material/LockPerson";

export default function Forbidden() {
    return (
        <Paper sx={{ height: "100%" }}>
            <Grid container spacing={6} sx={{ p: 10 }}>
                <Grid size={{ md: 6 }} sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <Typography variant="h2" component="h1" gutterBottom>
                        Access Denied,
                    </Typography>
                    <Typography variant="h5" component="h2" gutterBottom>
                        You do not have permission to access this component. Please contact your Administrator to report the issue.
                    </Typography>
                </Grid>
                <Grid size={{ md: 6 }} sx={{ display: { xs: "none", md: "block" } }}>
                    <LockPersonIcon sx={{ height: "200px", width: "200px" }} />
                </Grid>
            </Grid>
        </Paper>
    );
}
